import CloseIcon from '../../../assets/icons/close.svg?react';
import { useUpdateSetUp, useDeleteSetUp } from '../../../hooks/queries/setUpQueries';
import { useAuth } from '../../../hooks/useAuth';
import { useState } from 'react';
const SystemSetUpConfirmModal = ({ data, onClose }) => {
  const { user } = useAuth();
  const updateSetUp = useUpdateSetUp();
  const deleteSetUp = useDeleteSetUp();
  const [isPending, setIsPending] = useState(false);
  const handleConfirm = async () => {
    setIsPending(true);
    try {
      await deleteSetUp.mutateAsync({
      group: data.Group,
      key: data.Key,
      valueType: data.ValueType,
      description: data.Description,
      });
      onClose();
    } catch (error) {
      console.error('시스템 구성 키 삭제 실패:', error);
      alert('시스템 구성 키 삭제에 실패했습니다.');
    } 
    finally {
      setIsPending(false);
    }
  }
  
  return (
    <div className="modal-background" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>시스템 구성 키 삭제 확인</h3>
          <button 
            className="close-btn"
            onClick={onClose}
          >
            <CloseIcon />
          </button>
        </div>
        <div className="modal-content">
          <p className="my-10 text-b2-400 text-gray-700">시스템 구성 키를 삭제하시겠습니까?</p>
          <table className="gray-table">
            <tr>
              <th width="100px">그룹</th>
              <td>{data.Group}</td>
            </tr>
            <tr>
              <th>키</th>
              <td>{data.Key}</td>
            </tr>
            <tr>
              <th>설명</th>
              <td>{data.Description}</td>
            </tr>
          </table>
        </div>
        <div className="modal-footer">
          <button className="btn big-btn btn-primary" onClick={handleConfirm}>{ isPending ? '삭제 중...' : '삭제'}</button>
          <button className="btn big-btn btn-style-5" onClick={onClose}>취소</button>
        </div>
      </div>
    </div>
  )
}

export default SystemSetUpConfirmModal